import React, {Component} from 'react';
import {Flex,ListView, Modal, Toast} from 'antd-mobile';
import icon_vip_img from '../../res/img/vip_sign.png'
import Config from '../../config/index';
import WxApi from '../../common/wxapi';
import {inject, observer} from 'mobx-react';
import ic_top_notice from "../../res/img/ic_detail_showmore.png"
import ic_invite_data from "../../res/img/ic_detail_list_data.png"
@inject("enrollStore", "loadingStore")
@observer
class UserList extends Component {
    constructor(props) {
        super(props);
        this.loadMoreTimer = null;
    }

    componentDidMount() {
        let {getEnrollUserList ,detail} = this.props.enrollStore;
		if(detail && this.props.is_await != 1 && (detail.count <= Number(detail.user_list_limit) || detail.admin1 == 1 || detail.is_owner)){ //根据后台接口的阈值来限制加载
			getEnrollUserList.bind(this.props.enrollStore)(this.props.eid);
		}
    }
	
	getUserList(row) {
		let {userDataSource, getEnrollUserList, userListLoading, userListNumCount, detail,enrollUserList} = this.props.enrollStore;
	    if(enrollUserList.length > 0 ){
			return(
				<div>
				{
					userListNumCount != 0 ? <ListView
					    ref={el => this.lv = el}
					    dataSource={userDataSource}
					    renderFooter={() => (<div style={{textAlign: 'center'}}>
					        {userListLoading ? '正在加载...' : ''}
					    </div>)}
					    renderRow={row}
					    useBodyScroll={true}
					    scrollRenderAheadDistance={100}
                        onEndReachedThreshold={10}
					    onEndReached={() => {
                            if (this.loadMoreTimer) {
                                clearTimeout(this.loadMoreTimer);
                            }
                            this.loadMoreTimer = setTimeout(()=>{
                                if(!userListLoading && enrollUserList.length < userListNumCount){                                   
                                    getEnrollUserList.bind(this.props.enrollStore)(this.props.eid)
                                }
                            }, 300)                            							
						}}
					
					/> : <div className={`no-data-tips`}>还没有人参与</div>
				}
				</div>
			)
		}else{
	
			if(detail && detail.count == 0){
				return(
				<div className={`no-data-tips`}>还没有人参与</div>
				)
			}else{
				return(
					<div className={"view-more-list"} onClick={() => {
                        if(!Config.TOKEN){
                            React.$wx.webLogin();
                            return;
                        }
                        if(this.props.is_await != 1 ){
                            this.props.enrollStore.getEnrollUserList();
                        }else{
                            Toast.loading('数据加载中，请稍等')
                        }						
					}}>查看参与人列表<img className='show-more-icon' src={ic_top_notice} /></div>
					
				)
			}
		}
	};

    // 管理工具栏：对齐小程序 detail.wxml enroll-sort-find-box（is_owner || admins_node.length || showDev）
    // admins_node 为后端返回的当前用户角色编号数组（1 查看/2 核销/3 通知/4 审核）；
    // 小程序 showDev 在 H5 直接取详情接口的 sup_vip：sup_vip=1 表示有上帝模式权限，其它值一律无权限
    hasSupVipPermission(detail) {
        return detail.sup_vip === 1 || detail.sup_vip === '1';
    }

    canShowAdminTools(detail) {
        return Number(detail.is_owner) === 1
            || (Array.isArray(detail.admins_node) && detail.admins_node.length > 0)
            || this.hasSupVipPermission(detail);
    }

    // 发通知展示条件对齐小程序 enroll.sup_vip || enroll.is_owner || enroll.has_admin_3
    // has_admin_3 即 admins_node 包含角色 3
    canShowNotice(detail) {
        const hasAdmin3 = Array.isArray(detail.admins_node) && detail.admins_node.some((item) => Number(item) === 3);
        return this.hasSupVipPermission(detail) || Number(detail.is_owner) === 1 || hasAdmin3;
    }

    goToolPage(path) {
        if (!Config.TOKEN) {
            React.$wx.webLogin();
            return;
        }
        if (this.props.history) {
            this.props.history.push(path);
        }
    }

    renderAdminTools(detail) {
        if (!detail || !detail.eid || !this.canShowAdminTools(detail)) {
            return null;
        }
        const eid = encodeURIComponent(detail.eid);
        return (
            <div className='admin-tools-bar'>
                <div className='admin-tool-item' onClick={() => {
                    this.goToolPage('/inviteData?eid=' + eid);
                }}>
                    <img src={ic_invite_data} />
                    <label>邀请统计</label>
                </div>
                <div className='admin-tool-item' onClick={() => {
                    this.goToolPage('/searchuser?eid=' + eid);
                }}>
                    <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-07-01/c19f83ebb5614f73f9ff1c5590af81f9.png" />
                    <label>查找</label>
                </div>
                <div className='admin-tool-item' onClick={() => {
                    // 核销签到页依赖 is_owner/auth/rank/temp 控制能力，跳转时一并带上
                    this.goToolPage('/checkin?eid=' + eid
                        + '&is_owner=' + (Number(detail.is_owner) === 1 || Number(detail.is_admin) === 1 ? 1 : 0)
                        + '&auth=' + (detail.auth || 0)
                        + '&rank=' + (detail.rank_switch || 0)
                        + '&temp=' + (detail.temp || 0));
                }}>
                    <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20231023/a5173f50ae8147f4d13b05b50546569b.png" />
                    <label>核销签到</label>
                </div>
                {
                    this.canShowNotice(detail) ?
                        <div className='admin-tool-item' onClick={() => {
                            this.goToolPage('/notice?eid=' + eid);
                        }}>
                            <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-03-17/2e1868c8ac1ab7af0d7bb569ffbb00f2.png" />
                            <label>发通知</label>
                        </div> : null
                }
            </div>
        );
    }

    render() {
        let {userListNumCount, detail} = this.props.enrollStore;
        const row = (rowData, sectionID, rowID) => {
            let getStatue = function () {
                // verified==4 待支付（最优先，无论是否开启 verify 都显示）
                if (rowData.verified == 4) {
                    return (
                        <div className={"Detail-item-des1 pending-pay"}>
                            待支付
                        </div>
                    )
                }
                // 排队中（无论是否开启 verify 都处理）
                if (rowData.verified == -1) {
                    return (
                        <div className={"Detail-item-des1 blue"}>
                            排队中
                        </div>
                    )
                }
                if (!!detail.verify) {
                    if (rowData.verified == 0) {
                        return (
                            <div className={"Detail-item-des1 blue"}>
                                待审核
                            </div>
                        )
                    }
                    else if (rowData.verified == 1) {
                        return (
                            <div className={"Detail-item-des1 gray"}>
                                通过
                                {
                                    rowData.refund && (detail.is_owner || detail.admin1 == 1) ?<span className='refund-text'>({rowData.refund == 1?'已退款':'退款失败'})</span>:''
                                }
                            </div>
                        )
                    }
                    else if (rowData.verified == 2) {
                        return (
                            <div className={"Detail-item-des1 red"}>
                                退回
                            </div>
                        )
                    }else if(rowData.verified == 3){
                        return (
						    <div className={"Detail-item-des1 red"}>
						        驳回
						    </div>
						)
                    }
                }
                // verify 未开启或其他未知状态，默认显示提交成功
                return (<div className="Detail-item-des1">
                    提交成功
                    {
                        rowData.refund && (detail.is_owner || detail.admin1 == 1) ?<span className='refund-text'>({rowData.refund == 1?'已退款':'退款失败'})</span>:''
                    }
                </div>)
            };

            let getName = function () {
                if(detail.user_visible == 1){
                    return (<div className="Detail-item-name">
                                <span className={rowData.card_vip ? 'vip-name':''}>{WxApi.getDefaultName(rowData.name)}</span>
                                {rowData.on_behalf ? <span className="tag-info">多</span> : null}
                            </div>)
                }
                else{
                    return (<div className={rowData.card_vip ? 'vip-name Detail-item-name':'Detail-item-name'}>**</div>)
                }
            };
			             
            return (
                <Flex key={rowID} className="Detail-list-item">
                    <img className='user-avatar' src={rowData.head_img||Config.defaultAvatar}/>
                    {
                        rowData.card_vip ? <img className='vip-img' src={icon_vip_img} /> : ''
                    }
                    <Flex justify={"between"} style={{"width": "100%"}} className="Detail-list-flexpanel">
                        <Flex.Item style={{"width": "150px"}}>
                            {
                                getName()
                            }
                            <div className="Detail-item-time">
                                {rowData.date_str}
                            </div>
                        </Flex.Item>
                        <Flex.Item className="Detail-item-des">
                            {
                                getStatue()
                            }
							{
								detail.rank_switch ? <div className="Detail-item-des2">
                                编号: {rowData.rank_no}
                            </div> : <div className="Detail-item-des2">
                                No. {userListNumCount - rowID}
                            </div>
							}
                        </Flex.Item>
                    </Flex>
                </Flex>
            );
        };
        const detailStyle = {
            width: '100%',
            height: '44px',
            position: 'absolute',
            right: '0',
            top: '0',
        }
        return (
            <div className="Detail-content-member">               
                <div className='tab-menu'>
                    <span className='tab-items focus-tab' style={{color: this.props.themColor, borderBottom: '2px solid '+ this.props.themColor}}>已提交({userListNumCount <= 0?detail.count :userListNumCount})</span>
                    <span className='tab-items' onClick={()=>{
                        if(!WxApi.isWeixn()){
                            Modal.alert('温馨提示','目前仅报名工具小程序支持查看「详细数据」，请前往小程序去完成吧',[{ text: '我知道了' }])
                        }
                    }}>
                        { detail.visibility == 1 ? "详细数据" : '' }
                        {
                            detail.visibility == 1 && WxApi.isWeixn() ?
                            <wx-open-launch-weapp id="coupon-btn" username="gh_ae6449501a82" style={detailStyle} path={this.props.wxJumpPath}> 
                                <script type="text/wxtag-template">
                                    <div style={detailStyle}></div>
                                </script>
                            </wx-open-launch-weapp> : ''
                        }
                    </span>                    
                </div>
                {this.renderAdminTools(detail)}
                <div className='msg-notification' onClick={()=>{
                    if(detail.is_fans){					
                        this.props.openMsg()        
                    }else{
                        window.location.href = 'https://mp.weixin.qq.com/s/7xoT8N4jJuR36X3UoZEQVg'
                    }                               
                }}>
                    <i className='notify-img iconfont icon-svg45-copy' style={{color: this.props.themColor}}></i>                     
                    <h2 className='notify-title'>订阅通知 <span className='notify-desc'>及时接收报名成功、取消等</span></h2>                   
                    <span className='notify-btn' style={{color: this.props.themColor}}>去订阅 ></span>
                </div>
                {
                    this.getUserList(row)                    
                }
            </div>
        )
    }
}

export default UserList;
